import { useAccount } from '@/domain/hooks/useAccount'
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@radix-ui/react-dropdown-menu'

import { UserProfileButton } from '@/features/navbar/components/wallet-button/UserProfileButton'
import { navWalletButtonStyles } from '@/features/navbar/components/wallet-button/ConnectButton'
import { useState } from 'react'
import { UserProfileCard } from '@/features/navbar/components/wallet-button/UserProfileCard'

export function WalletButton() {
  const address = useAccount()
  const [isOpen, setIsOpen] = useState(false)

  if (!address) return null

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <UserProfileButton address={address} className={navWalletButtonStyles()} onClick={() => setIsOpen(true)} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="z-[260] mt-2 rounded-md border border-border-light bg-background p-0">
        <UserProfileCard />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
